import React from "react";
import { withNavBars } from "../../HOCs";
import RentalIndex from "./rentalIndex";

class RentalIndextParent extends React.Component {
    render() {
        return <RentalIndex />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(RentalIndextParent, props);
